import { render, staticRenderFns } from "./update.modal.vue?vue&type=template&id=3c784ede&"
import script from "./update.modal.vue?vue&type=script&lang=js&"
export * from "./update.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports